import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (
  state: RootState,
) => state['feature/ent-acc/edit-ent-acc/expert/edit-expert/certificates'] || initialState;

export const selectExpertCertificates = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.expertCertificates,
);
export const selectExpertCertificatesLoader = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.certificatesStateLoading,
);
export const selectExpertCertificatesRefetchTrigger = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.certificatesRefetchTrigger,
);
export const selectIssuingExpertCertificateUserSessionId = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.issuingCertificateUserSessionId,
);
export const selectBulkIssuingExpertCertificatesLoading = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.bulkIssuingCertificatesLoading,
);
export const selectRevokingCertificateId = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.revokingCertificateId,
);
export const selectExpertCertificateExpertId = createSelector(
  [selectDomain],
  (expertCertificatesState) => expertCertificatesState.expertId,
);
